/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method,payload) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//employee list
export function loadEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_filter`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
// list
export async function loadManageObsLeadDetails(searchFilter) {

    return await api
      .post(`/get_obs_others_and_rejected_details`,searchFilter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
 
}
// add assing
export async function  addAssignRemote(submitAssign) {
  return await api
    .post(`/obs_lead_multi_assign`,submitAssign)
    .catch((error) => Promise.reject(error))
}

// add followup 
export async function  addFollowUpRemote(submitFollowUp) {
  return await api
    .post(`/obs_lead_followup_data`,submitFollowUp)
    .catch((error) => Promise.reject(error))
}
//load followup
export function loadFollowUpDetails(ID) {
 

  return api
    .post(`/obs_lead_fllowup_history`, ID)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//load followup
export function loadCompanyDetails() {
  return api
    .post(`/getAllCompetitorCompany`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
export async function  addCompanyDetails(company_details) {
  return await api
    .post(`/addCompetitorCompany`,company_details)
    .catch((error) => Promise.reject(error))
}
const remotes = {
  loadRecordsMetaData,
  loadEmployeeList,
  loadManageObsLeadDetails,
  addAssignRemote,
  addFollowUpRemote,
  loadFollowUpDetails,
  loadCompanyDetails,
  addCompanyDetails
}

export default remotes
